/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Standards_Preset_Save_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to save preset: {error}" |
*
* @param {Standards_Preset_Save_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const standards_preset_save_failed_toast = /** @type {((inputs: Standards_Preset_Save_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Standards_Preset_Save_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Failed to save preset: ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Failed to save preset: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Failed to save preset: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Failed to save preset: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Failed to save preset: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`Failed to save preset: ${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`Failed to save preset: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`Failed to save preset: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Failed to save preset: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to save preset: ${i?.error}`)
});